<mat-tab-group>
  <!-- Despachos del día -->
  <mat-tab label="Despachos">
    <ng-template matTabContent>
      <app-asignar-despachos></app-asignar-despachos>
    </ng-template>
  </mat-tab>

  <!-- Historial -->
  <mat-tab label="Historial">
    <ng-template matTabContent>
      <app-listado></app-listado>
    </ng-template>
  </mat-tab>
</mat-tab-group>
